import type { RewardItem } from '@/types/reward'

import { resolveRewardPartner } from './resolveItemPartner'
import { resolveItemRewardCategory } from './resolveItemRewardCategory'
import type { StoreCatalogItem } from './types'

type PartnerLookup = Record<string, string>

export type RewardRequestPartnerMeta = {
  partner: string | null
  category: string | null
}

export const resolveRewardRequestPartnerMeta = (
  rewardItem: RewardItem | null | undefined,
  partnerNameById: PartnerLookup = {}
): RewardRequestPartnerMeta => {
  const partnerRef = resolveRewardPartner(
    rewardItem as StoreCatalogItem,
    partnerNameById
  )
  const categoryRef = resolveItemRewardCategory(rewardItem as StoreCatalogItem)

  if (!partnerRef && !categoryRef) {
    return { partner: null, category: null }
  }

  return {
    partner: partnerRef?.label ?? null,
    category: categoryRef?.name ?? null
  }
}

export const formatRewardRequestPartnerMeta = ({
  partner,
  category
}: RewardRequestPartnerMeta): string | null => {
  const parts = [category, partner].filter(Boolean)

  return parts.length > 0 ? parts.join(' · ') : null
}
